if (!customElements.get('flavor-showcase-carousel')) {
  customElements.define(
    'flavor-showcase-carousel',
    class FlavorShowcaseCarousel extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('.flavor-showcase__track');
        this.cards = Array.from(this.querySelectorAll('.flavor-showcase__card'));
        this.dots = Array.from(this.querySelectorAll('.flavor-showcase__dot'));
        this.previousButton = this.querySelector('.flavor-showcase__arrow--previous');
        this.nextButton = this.querySelector('.flavor-showcase__arrow--next');
        this.activeIndex = 0;
      }

      connectedCallback() {
        if (!this.track || this.cards.length === 0) return;

        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.previousButton?.addEventListener('click', this.showPrevious);
        this.nextButton?.addEventListener('click', this.showNext);
        this.dots.forEach((dot) => dot.addEventListener('click', this.showFromDot));
        this.updateNavigation(0);
      }

      handleScroll = () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          const trackRect = this.track.getBoundingClientRect();
          const trackCenter = trackRect.left + trackRect.width / 2;
          const index = this.cards.reduce(
            (closestIndex, card, cardIndex) => {
              const cardRect = card.getBoundingClientRect();
              const distance = Math.abs(cardRect.left + cardRect.width / 2 - trackCenter);
              return distance < closestIndex.distance ? { index: cardIndex, distance } : closestIndex;
            },
            { index: 0, distance: Number.POSITIVE_INFINITY }
          ).index;

          this.updateNavigation(index);
        });
      };

      showPrevious = () => {
        this.showCard(Math.max(0, this.activeIndex - 1));
      };

      showNext = () => {
        this.showCard(Math.min(this.cards.length - 1, this.activeIndex + 1));
      };

      showFromDot = (event) => {
        this.showCard(Number(event.currentTarget.dataset.flavorIndex));
      };

      showCard(index) {
        const card = this.cards[index];
        if (!card) return;

        card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        this.updateNavigation(index);
      }

      updateNavigation(index) {
        this.activeIndex = index;
        this.cards.forEach((card, cardIndex) =>
          card.classList.toggle('flavor-showcase__card--active', cardIndex === index)
        );
        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        if (this.previousButton) this.previousButton.disabled = index === 0;
        if (this.nextButton) this.nextButton.disabled = index === this.cards.length - 1;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.scrollFrame);
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.previousButton?.removeEventListener('click', this.showPrevious);
        this.nextButton?.removeEventListener('click', this.showNext);
        this.dots.forEach((dot) => dot.removeEventListener('click', this.showFromDot));
      }
    }
  );
}
